import { request } from 'http'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import * as actions from '../../state/actions/drivers'
import SessionHistoryAddTimeModal from 'src/components/drivers/SessionHistoryAddTimeModal'
import { IDriverAddSessionObject } from 'src/types/driver'
import { IStoreState } from 'src/types/state'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  console.log(ownProps)

  return {
    history: ownProps.history,
    match: ownProps.match,
    operatorId: ownProps.operatorId,
    fromDate: ownProps.filters.fromDate,
    toDate: ownProps.filters.toDate
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveData: async (request: IDriverAddSessionObject): Promise<any> => {
      return await dispatch(actions.createDriverSession(request))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SessionHistoryAddTimeModal)



// WEBPACK FOOTER //
// ./src/containers/drivers/SessionHistoryAddTimeModal.ts